<template>
  <div v-if="tooltip">
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <Button
          v-on="on"
          class="flex-column uploader-container blue-grey lighten-3"
          outlined
          :icon="icon"
          :class="{
            'uploader-container--dragging': isDraggingFile,
            'uploader-container--small': small,
          }"
          :color="isDraggingFile ? 'primary' : 'blueGrey'"
          @click="$emit('select')"
        />
      </template>

      {{ tooltip }}
    </v-tooltip>
  </div>

  <Button
    v-else
    class="flex-column uploader-container blue-grey lighten-3"
    outlined
    :icon="icon"
    :class="{
      'uploader-container--dragging': isDraggingFile,
      'uploader-container--small': small,
    }"
    :color="isDraggingFile ? 'primary' : 'blueGrey'"
    @click="$emit('select')"
  />
</template>

<script>
import Button from '@/components/UI/Button'
export default {
  name: 'MediaContainerThumbnailUploader',
  components: {
    Button,
  },
  props: {
    isDraggingFile: Boolean,

    small: Boolean,

    icon: {
      type: String,
      default: 'mdi-image-plus',
    },

    tooltip: {
      type: String,
      default: null,
    },
  },
}
</script>

<style lang="scss" scoped>
.uploader-container {
  width: 80px !important;
  height: 80px !important;
  min-width: 80px !important;
  max-width: 80px !important;
  border-radius: 12px;

  &--small {
    width: 60px !important;
    height: 60px !important;
    min-width: 60px !important;
    max-width: 60px !important;
    border-radius: 8px;
  }

  &--dragging {
    background-color: var(--v-blue-lighten5);
    border-color: var(--v-primary-base);
  }
}
</style>
